// import Joi from 'joi-browser';
import HttpService from '@pingum/api-services/HttpService';

export default class TagReminderService {
  static getTagReminders(status, eventTemplateReminderId, page, size, sort) {
    return this.httpService.get(`?status=${status || ''}&eventTemplateReminderId=${eventTemplateReminderId || ''}&page=${page}&size=${size}${sort}`);
  }

  static getTagReminder(tagReminderId) {
    return this.httpService.get(`/${tagReminderId}`);
  }

  static getTagRemindersForDueDate(tagIds, maxDueDate) {
    return this.httpService.get(`/dueDates?tagIds=${tagIds || []}&maxDueDate=${(maxDueDate && maxDueDate.toISOString()) || ''}`);
  }
}

TagReminderService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_EVENT_API
    : ''}/tagReminders`,
});
